import React from 'react';

export function DeepDocsBrand({ onClick, logoUrl, compact = false }) {
  return (
    <button
      type="button"
      className={`flex items-center rounded-full py-1 pr-2 transition-colors hover:bg-white/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent/50 ${compact ? 'gap-2' : 'gap-2.5'}`}
      onClick={onClick}
      aria-label="DeepDocs home"
    >
      {logoUrl && (
        <span className={`relative overflow-hidden shrink-0 rounded-[6px] ${compact ? 'h-6 w-6' : 'h-8 w-8'}`} aria-hidden="true">
          <img
            src={logoUrl}
            alt=""
            className={`w-auto max-w-none ${compact ? 'h-6' : 'h-8'}`}
          />
        </span>
      )}
      <span className={`font-semibold tracking-tight text-white ${compact ? 'text-[15px]' : 'text-[19px] leading-none'}`}>
        DeepDocs
      </span>
    </button>
  );
}
